import { Entity } from '@/interfaces/entity';
import { BusinessUnit } from './business_unit'

export class Location implements Entity{
    id: string;
    business_unit: BusinessUnit;
    name: string;
    description: string;

    constructor(id='', business_unit = new BusinessUnit(), name = "", description = ""){
        this.id = id;
        this.business_unit = business_unit;
        this.name = name;
        this.description = description;
    }
}